import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import type { WorkItem } from '@/types/work'

const PRIORITY_BAR: Record<string, string> = {
  urgent: 'var(--color-state-blocked)',
  high: 'var(--color-accent-500)',
  normal: 'transparent',
  low: 'transparent',
}

export function BoardCard({ item, overlay = false }: { item: WorkItem; overlay?: boolean }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: item.id,
    disabled: overlay,
  })

  return (
    <article
      ref={overlay ? undefined : setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
      }}
      {...(overlay ? {} : attributes)}
      {...(overlay ? {} : listeners)}
      className={`border-line bg-surface cursor-grab rounded-md border p-3 ${
        overlay ? 'shadow-lg' : ''
      }`}
    >
      <div className="flex items-start gap-2">
        <span
          aria-hidden="true"
          className="mt-1 h-3 w-0.5 shrink-0 rounded"
          style={{ backgroundColor: PRIORITY_BAR[item.priority] ?? 'transparent' }}
        />
        <p className="text-ink-900 min-w-0 flex-1 text-sm leading-snug">{item.title}</p>
      </div>

      <div className="mt-2.5 flex items-center gap-2">
        <span className="text-brand-600 font-mono text-[11px]">{item.key}</span>

        {item.visibility === 'client' ? (
          <span className="border-brand-300 text-brand-600 rounded border px-1.5 py-px font-mono text-[10px]">
            client
          </span>
        ) : null}

        <span className="flex-1" />

        {item.commentCount > 0 ? (
          <span className="text-ink-500 font-mono text-[11px] tabular-nums">
            {item.commentCount}c
          </span>
        ) : null}

        {item.assignee ? (
          <span
            className="size-5 shrink-0 rounded-full"
            style={{ backgroundColor: item.assignee.color ?? 'var(--color-ink-500)' }}
            title={item.assignee.name}
          />
        ) : null}
      </div>
    </article>
  )
}
